export function toNum(v: unknown): number {
  if (v == null) return 0;
  if (typeof v === "number") return v;
  if (typeof v === "object" && v !== null && "toNumber" in v) {
    return (v as { toNumber(): number }).toNumber();
  }
  return Number(v);
}

export function formatKES(cents: unknown): string {
  const shillings = Math.round(toNum(cents) / 100);
  return "KES " + shillings.toLocaleString("en-KE");
}

const STATUS_LABELS: Record<string, string> = {
  REGISTERED: "Registered",
  RECEIVED_ABROAD: "In transit to Kenya",
  RECEIVED_KENYA: "Awaiting payment",
  ON_HOLD: "On hold",
  PAID: "Awaiting settlement",
  OUT_FOR_DELIVERY: "Out for delivery",
  DELIVERED: "Delivered",
};

export function statusLabel(status: string | null | undefined): string {
  return STATUS_LABELS[status ?? ""] ?? (status ?? "");
}

export type BadgeVariant = "default" | "secondary" | "destructive" | "success" | "warning" | "outline";

export function statusBadgeVariant(status: string | null | undefined): BadgeVariant {
  switch (status) {
    case "OUT_FOR_DELIVERY":
    case "DELIVERED":
      return "success";
    case "RECEIVED_KENYA":
    case "PAID":
      return "warning";
    case "ON_HOLD":
      return "destructive";
    default:
      return "secondary";
  }
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleString("en-KE", { dateStyle: "medium", timeStyle: "short" });
}

export function formatDay(iso: string | null | undefined): string {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString("en-KE", { day: "numeric", month: "short" });
}

export function etaIsLate(maxIso: string | null | undefined, status: string | null | undefined): boolean {
  if (!maxIso || status === "DELIVERED") return false;
  const d = new Date(maxIso);
  return !Number.isNaN(d.getTime()) && d.getTime() < Date.now();
}

export function formatEta(minIso: string | null | undefined, maxIso: string | null | undefined): string {
  const from = formatDay(minIso);
  const to = formatDay(maxIso);
  if (from && to) return from === to ? from : `${from} to ${to}`;
  if (to) return `by ${to}`;
  if (from) return `from ${from}`;
  return "";
}
